'use client';

import classNames from 'classnames';
import { GetPageComponentViewModel } from '@/types/cml-api';
import { deviceTypeClassGenerator } from '@/app/(home-page)/_utils/device-type-handlers';
import CarouselBrandItem from './carousel-brand-item';
import { IsLoadingLazyProps } from '../../type';
interface Props extends IsLoadingLazyProps {
  data: GetPageComponentViewModel;
}
function CarouselBrand({
  data,
  isLazy
}: Props) {
  return <div className={classNames('homepage-container !pl-0', deviceTypeClassGenerator(data.deviceTypes || ''))} data-sentry-component="CarouselBrand" data-sentry-source-file="carousel-brand.tsx">
            <div className='w-full'>
                <span className='mb-1.5 block py-1.5 text-body-14 font-bold lg:mb-4 lg:py-2 lg:text-body-16'>
                    {data.title}
                </span>
                {!!data.items?.length && <div className='relative grid w-full grid-cols-4 justify-items-center gap-y-1 lg:grid-cols-6 lg:gap-y-2'>
                        {data.items.map((brand, index) => <CarouselBrandItem key={brand.id || brand?.mobileImageUrl} isLazy={isLazy} index={index} sortKey={data?.sortKey} componentId={data?.id} {...brand} />)}
                    </div>}
            </div>
        </div>;
}
export default CarouselBrand;